import {dashboardApiConfig, ops} from "./config";
import {
  CloverAuthReqDto,
  CloverRestaurantDto,
  DesignDto, PopmenuAuthReqDto,
  PosResourceApi,
  ReplaceCloverItemDto,
  ReplaceSquareItemDto,
  ReplaceToastItemDto,
  SquareAuthReqDto,
  SquareDeltaUpdate,
  SquareDeltaUpdateResponse,
  SquareRestaurantDto,
  ToastDeltaUpdate,
  ToastDeltaUpdateDesignResponse,
  ToastDeltaUpdateResponse,
  ToastRestaurantDto, TreezDeltaUpdate, TreezDeltaUpdateDesignResponse, TreezDeltaUpdateResponse, TreezRestaurantDto
} from "../generated/dashboard-client";
import {AxiosPromise} from "axios";

const posApi = new PosResourceApi(dashboardApiConfig);

const PosApi = {
  getToastRestaurants(email: string): AxiosPromise<ToastRestaurantDto[]> {
    return posApi.getToastRestaurants(email, ops());
  },
  getToastPendingChanges(restaurantId: string): AxiosPromise<ToastDeltaUpdate[]> {
    return posApi.getToastPendingChanges(restaurantId, 'PENDING', ops());
  },
  getToastApprovedChanges(restaurantId: string): AxiosPromise<ToastDeltaUpdate[]> {
    return posApi.getToastPendingChanges(restaurantId, 'APPROVED', ops());
  },
  updateToastPendingChanges(restaurantId: string, dto: ToastDeltaUpdateResponse[]): AxiosPromise<void> {
    return posApi.updateToastPendingChanges(restaurantId, dto, ops());
  },
  getDesignsUsingToast(locationId: number): AxiosPromise<DesignDto[]> {
    return posApi.getDesignsUsingToast(locationId, ops());
  },
  replaceToastItems(entries: ReplaceToastItemDto[]): AxiosPromise<void> {
    return posApi.replaceToastItems(entries, ops());
  },
  addToastChangeSolvedInDesignId(restaurantId: string, changeId: string, dto: ToastDeltaUpdateDesignResponse): AxiosPromise<void> {
    return posApi.addToastChangeSolvedInDesignId(restaurantId, changeId, dto, ops());
  },
  authClover(dto: CloverAuthReqDto): AxiosPromise<void> {
    return posApi.authClover(dto, ops());
  },
  getDesignsUsingClover(locationId: number): AxiosPromise<DesignDto[]> {
    return posApi.getDesignsUsingClover(locationId, ops());
  },
  getCloverRestaurants(): AxiosPromise<CloverRestaurantDto[]> {
    return posApi.getCloverRestaurants(ops());
  },
  getCloverPendingChanges(restaurantId: string): AxiosPromise<ToastDeltaUpdate[]> {
    return posApi.getCloverPendingChanges(restaurantId, 'PENDING', ops());
  },
  replaceCloverItems(entries: ReplaceCloverItemDto[]): AxiosPromise<void> {
    return posApi.replaceCloverItems(entries, ops());
  },
  updateCloverPendingChanges(restaurantId: string, dto: ToastDeltaUpdateResponse[]): AxiosPromise<void> {
    return posApi.updateCloverPendingChanges(restaurantId, dto, ops());
  },
  addCloverChangeSolvedInDesignId(restaurantId: string, changeId: string, dto: ToastDeltaUpdateDesignResponse): AxiosPromise<void> {
    return posApi.addCloverChangeSolvedInDesignId(restaurantId, changeId, dto, ops());
  },
  //square
  authSquare(dto: SquareAuthReqDto): AxiosPromise<void> {
    return posApi.authSquare(dto, ops());
  },
  getDesignsUsingSquare(locationId: number): AxiosPromise<DesignDto[]> {
    return posApi.getDesignsUsingSquare(locationId, ops());
  },
  getSquareRestaurants(): AxiosPromise<SquareRestaurantDto[]> {
    return posApi.getSquareRestaurants(ops());
  },
  getSquarePendingChanges(restaurantId: string): AxiosPromise<SquareDeltaUpdate[]> {
    return posApi.getSquarePendingChanges(restaurantId, 'PENDING', ops());
  },
  replaceSquareItems(entries: ReplaceSquareItemDto[]): AxiosPromise<void> {
    return posApi.replaceSquareItems(entries, ops());
  },
  updateSquarePendingChanges(restaurantId: string, dto: SquareDeltaUpdateResponse[]): AxiosPromise<void> {
    return posApi.updateSquarePendingChanges(restaurantId, dto, ops());
  },
  addSquareChangeSolvedInDesignId(restaurantId: string, changeId: string, dto: ToastDeltaUpdateDesignResponse): AxiosPromise<void> {
    return posApi.addSquareChangeSolvedInDesignId(restaurantId, changeId, dto, ops());
  },
  //treez
  getDesignsUsingTreez(locationId: number): AxiosPromise<DesignDto[]> {
    return posApi.getDesignsUsingTreez(locationId, ops());
  },
  getTreezRestaurants(): AxiosPromise<TreezRestaurantDto[]> {
    return posApi.getTreezRestaurants(ops());
  },
  getTreezPendingChanges(restaurantId: string): AxiosPromise<TreezDeltaUpdate[]> {
    return posApi.getTreezPendingChanges(restaurantId, 'PENDING', ops());
  },
  replaceTreezItems(entries: ReplaceSquareItemDto[]): AxiosPromise<void> {
    return posApi.replaceTreezItems(entries, ops());
  },
  updateTreezPendingChanges(restaurantId: string, dto: TreezDeltaUpdateResponse[]): AxiosPromise<void> {
    return posApi.updateTreezPendingChanges(restaurantId, dto, ops());
  },
  addTreezChangeSolvedInDesignId(restaurantId: string, changeId: string, dto: TreezDeltaUpdateDesignResponse): AxiosPromise<void> {
    return posApi.addTreezChangeSolvedInDesignId(restaurantId, changeId, dto, ops());
  },
  //popmenu
  authPopmenu(dto: PopmenuAuthReqDto): AxiosPromise<void> {
    return posApi.authPopmenu(dto, ops());
  },
};

export default PosApi;
